import isDefined from './is-defined'

export function showSysButton() {
  window._8select.initCSE() // trigger widget-loader again for async added sys-buttons

  const target = findTarget()
  const legacySysButton = window._8select.utils.widgetLoader.findWidgetByType('SysPsvButton')
  if (target && isDefined(legacySysButton)) {
    legacySysButton.activate()

    return
  }

  const sysButton = window._8select.utils.widgetLoader.findWidgetByType('SysButton')
  if (target && isDefined(sysButton)) {
    sysButton.activate()

    return
  }

  if ((isDefined(sysButton) || isDefined(legacySysButton)) && isDefined(target) === false) {
    console.warn('No target widget found for 8.SET Teaser Button - we keep it hidden.')
  }
}

function findTarget() {
  return (
    window._8select.utils.widgetLoader.findWidgetByType('SysPsv') ||
    window._8select.utils.widgetLoader.findWidgetByType('SysBar') ||
    window._8select.utils.widgetLoader.findWidgetByType('SetCompose')
  )
}

export default showSysButton
